var abGlyphs = window.abGlyphs || ((t) => (/[\u0590-\u08ff\u0900-\u0dff\ufb1d-\ufefc]/.test(t) ? t.split(/(\s+)/).filter(Boolean) : [...t])); // shared by the MOGRT scripts, so a page loading two of them still runs both; joined scripts (Arabic, Hindi) animate by word so letters stay connected
/*
 * Text Wiggle step 3 demo (snippets/mogrt-demo-wiggle.liquid), run by
 * assets/mogrt-steps-demo.js: type the text, and each letter wiggles in the
 * Program monitor as it arrives; then the panel turns Speed up and Anchor
 * Point to Bottom, and the letters wiggle faster, turning on their feet.
 */
(() => {
  const RATE = { calm: 2.2, fast: 5.5 }; // new turns a second at Speed 30 and 75
  const TURN = 9; // degrees at most
  const LIFT = 0.07; // em at most
  const SHARE = 0.2; // Correlation 20: how much the letters move together
  const KNOB = 340; // the Speed knob starts to glide this long after live (its row's delay)

  // smooth value noise from -1 to 1 (the same wander as the use-case tiles)
  const hash = (n) => {
    const x = Math.sin(n * 127.1 + 311.7) * 43758.5453;
    return (x - Math.floor(x)) * 2 - 1;
  };
  const noiseValues = new Map();
  const noise = (seed, x) => {
    const i = Math.floor(x);
    let values = noiseValues.get(seed);
    if (!values || values.i !== i) {
      values = { i, from: hash(seed + i * 7.31), to: hash(seed + (i + 1) * 7.31) };
      noiseValues.set(seed, values);
    }
    const f = x - i;
    const u = f * f * (3 - 2 * f);
    return values.from * (1 - u) + values.to * u;
  };

  const parts = (screen) => ({
    field: screen.querySelector('[data-eg-text]'),
    line: screen.querySelector('[data-mdw-line]'),
  });

  // the monitor shows what the field says, a span per letter
  const letters = new WeakMap();
  const write = (line, text) => {
    if (line.dataset.text === text && letters.has(line)) return letters.get(line);
    line.dataset.text = text;
    line.textContent = '';
    const chars = [];
    abGlyphs(text).forEach((ch) => {
      if (/\s/.test(ch)) return line.append(ch);
      const span = document.createElement('span');
      span.className = 'mdw-char';
      span.textContent = ch;
      line.append(span);
      chars.push(span);
    });
    letters.set(line, chars);
    return chars;
  };

  const pose = (chars, phase) => {
    const keep = 1 / Math.hypot(1 - SHARE, SHARE);
    const turnAll = noise(91.3, phase);
    const liftAll = noise(53.1, phase * 0.9);
    chars.forEach((ch, i) => {
      const turn = ((1 - SHARE) * noise(i * 3.7, phase) + SHARE * turnAll) * keep;
      const lift = ((1 - SHARE) * noise(i * 3.7 + 1.9, phase * 0.9) + SHARE * liftAll) * keep;
      ch.style.transform = `translateY(${(lift * LIFT).toFixed(3)}em) rotate(${(turn * TURN).toFixed(2)}deg)`;
    });
  };

  // one frame loop per screen at a time
  const loops = new WeakMap();

  window.MogrtDemos = window.MogrtDemos || {};
  window.MogrtDemos.wiggle = {
    rest(screen) {
      const p = parts(screen);
      loops.delete(screen);
      p.field.dataset.full = p.field.dataset.full || p.field.textContent.trim();
      p.field.textContent = p.field.dataset.full;
      p.field.classList.remove('is-typing');
      screen.setAttribute('data-live', '');
      pose(write(p.line, p.field.dataset.full), 2.35);
    },
    async pass(screen, t) {
      const p = parts(screen);
      const text = p.field.dataset.full;
      p.field.textContent = '';
      write(p.line, '');

      // while the pass runs, the letters follow the field and wiggle; the
      // speed eases up with the Speed knob once the panel goes live
      const me = {};
      loops.set(screen, me);
      let phase = 0;
      let rate = RATE.calm;
      let liveAt = 0;
      let last = performance.now();
      const tick = (now) => {
        if (!t.alive() || loops.get(screen) !== me) return;
        const dt = Math.min(64, now - last);
        last = now;
        const live = screen.hasAttribute('data-live');
        if (live && !liveAt) liveAt = now;
        const target = live && now - liveAt > KNOB ? RATE.fast : RATE.calm;
        rate += (target - rate) * (1 - Math.exp(-dt / 300));
        phase += (dt / 1000) * rate;
        pose(write(p.line, p.field.textContent), phase);
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);

      if (!(await t.wait(500))) return false;
      if (!(await t.type(p.field, text, { speed: 110 }))) return false;
      if (!(await t.wait(1500))) return false;
      t.live(true);
      if (!(await t.wait(4200))) return false;
      loops.delete(screen);
      return true;
    },
  };
})();

